import { getCurrentCompany } from '../../../services/user'
import {UserActionTypes, UserAction, UserState} from '../../types/user'
    
    const initialState = {
        companyData: getCurrentCompany(),
        inProgress: false,
        isCompChange: false,
    }
const userReducer = (state = initialState, action: UserAction) : UserState => {
switch (action.type) {
    case UserActionTypes.ADD_ACTIVE_COMPANY_REQUEST:
      return {
        ...state,
        inProgress: true,
        isCompChange: true,
      }
    case UserActionTypes.ADD_ACTIVE_COMPANY_SUCCESS:
      return {
        ...state,
        companyData: action.payload,
        inProgress: false,
        isCompChange: false,
      }
      case UserActionTypes.ADD_ACTIVE_COMPANY_ERROR:
        return {
          ...state,
          notify: false,
          isCompChange: false,
        }
  
      default:
        return state;
    }
}
export default userReducer
